import axios from "axios";
import { Base_URL } from "../url";

export const saveFundsCenterDetails = async (fundsData, username) => {
  try {
    const response = await axios.post(
      `${Base_URL}/FundsCenter/CreateFundsCenter?userName=${username}`,
      fundsData
    );
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving funds center details!";
  }
};